<h4 mat-dialog-title>Are you sure you want to delete this order?</h4>

<mat-dialog-actions align="end">
  <button type="button" id="cancel-button" class="action-button" (click)="cancel()">CANCEL</button>
  <button type="button" id="delete-button" class="action-button" (click)="confirm()">DELETE</button>
</mat-dialog-actions>
